// module.exports.url = "http://38.242.139.102/qrapp/WebJsonService.asmx";
// module.exports.url = "http://localhost:8000/api/v1";
module.exports.url = "https://partners.limelightdesigns.in/api/v1";
module.exports.image = "https://partners.limelightdesigns.in/images";
// module.exports.image = "http://localhost:8000/images";
// module.exports.image = "http://110.227.212.114/colordesign";
// module.exports.image = "http://38.242.139.102/colordesign";